import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceOverview = () => {
  const services = [
    {
      id: 1,
      title: "Vérification de Propriété",
      description: "Authentification complète des titres de propriété et vérification de l'historique légal",
      icon: "Shield",
      price: "75,000 XOF",
      duration: "3-5 jours ouvrables",
      color: "from-blue-600 to-cyan-500",
      iconColor: "text-cyan-400"
    },
    {
      id: 2,
      title: "Transfert de Titre",
      description: "Processus complet de transfert de propriété avec assistance notariale",
      icon: "FileText",
      price: "150,000 XOF",
      duration: "7-10 jours ouvrables",
      color: "from-emerald-600 to-teal-500",
      iconColor: "text-emerald-400"
    },
    {
      id: 3,
      title: "Consultation Juridique",
      description: "Conseils personnalisés sur les réglementations immobilières ivoiriennes",
      icon: "Scale",
      price: "25,000 XOF",
      duration: "1 heure",
      color: "from-brand-gold to-yellow-600",
      iconColor: "text-brand-gold"
    },
    {
      id: 4,
      title: "Préparation de Documents",
      description: "Assistance complète pour tous les documents requis",
      icon: "FileCheck",
      price: "50,000 XOF",
      duration: "2-3 jours ouvrables",
      color: "from-purple-600 to-pink-500",
      iconColor: "text-pink-400"
    }
  ];

  return (
    <section className="py-24 bg-transparent border-none outline-none relative z-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* En-tête */}
        <div className="text-center mb-16">
          <p className="text-xs font-bold text-brand-gold uppercase tracking-widest mb-3">
            Expertise & Transparence
          </p>
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-white mb-6 tracking-tight">
            Services Juridiques Complets
          </h2>
          <p className="text-lg text-white/50 max-w-2xl mx-auto font-light leading-relaxed">
            Notre partenariat avec des notaires certifiés vous garantit une transaction immobilière sécurisée et conforme à la législation ivoirienne.
          </p>
        </div>

        {/* Grille des services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {services?.map((service) => (
            <div 
              key={service?.id} 
              className="bg-[#111111] rounded-3xl p-8 shadow-2xl hover:-translate-y-2 transition-all duration-500 border-none outline-none flex flex-col group relative overflow-hidden"
            >
              {/* Effet lumineux interne au survol */}
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-10 blur-3xl transition-opacity duration-500 rounded-full`} />

              <div className={`w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center mb-6 shadow-inner relative z-10`}>
                <Icon name={service?.icon} size={24} className={service.iconColor} />
              </div>
              
              <h3 className="text-xl font-heading font-bold text-white mb-3 tracking-tight relative z-10">
                {service?.title}
              </h3>
              
              <p className="text-white/50 text-sm font-light leading-relaxed mb-8 flex-grow relative z-10">
                {service?.description}
              </p>
              
              <div className="space-y-3 relative z-10 bg-white/[0.02] p-4 rounded-2xl border-none">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold uppercase tracking-widest text-white/30">Prix</span>
                  <span className="font-bold text-white">{service?.price}</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-bold uppercase tracking-widest text-white/30">Délai</span>
                  <span className="text-sm font-medium text-white/70">{service?.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bannière d'Information (Processus Complet) */}
        <div className="bg-gradient-to-r from-blue-900/30 to-[#111111] rounded-3xl p-10 md:p-12 shadow-2xl border-none outline-none relative overflow-hidden">
          {/* Halo d'arrière plan */}
          <div className="absolute inset-0 bg-blue-500/5 blur-3xl rounded-full pointer-events-none" />
          
          <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center gap-8">
            <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg">
              <Icon name="Info" size={32} className="text-blue-400" />
            </div>
            <div>
              <h3 className="text-2xl font-heading font-bold text-white mb-3 tracking-tight">
                Processus Légal Complet
              </h3>
              <p className="text-white/60 font-light leading-relaxed max-w-4xl">
                Notre processus couvre toutes les étapes essentielles : vérification initiale des documents, 
                authentification des titres de propriété, préparation des actes notariés, signature officielle, 
                et enregistrement final auprès des autorités compétentes. Chaque étape est transparente avec 
                un <strong className="text-white font-medium">suivi en temps réel</strong> de votre dossier.
              </p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ServiceOverview;